import React from "react";
import { Pressable, StyleSheet, Text, View } from "react-native";
import { MaterialCommunityIcons } from "@expo/vector-icons";

import { themes } from "@/Components/Styling/themeConfigs";
import { Spacings } from "@/styling/spacings";
import BaseItemCard from "@/Components/Cards/BaseItemCard";

type Props = {
  iconComponent: React.ReactNode;
  title: string;
  description: string;
  totalScore: number;
  earnedScore?: number;
  statusComponent: React.ReactNode;
  isCompleted: boolean;
  onPressActionButton: () => void;
};

function UnlockUsersBaseCard({
  iconComponent,
  title,
  description,
  totalScore,
  earnedScore,
  statusComponent,
  isCompleted,
  onPressActionButton,
}: Props): React.JSX.Element {
  const currentTheme = themes.morning;

  const styles = StyleSheet.create({
    container: {
      paddingHorizontal: Spacings.s3,
      marginVertical: Spacings.s1,
      backgroundColor: isCompleted ? "#f5f5f5" : "#fff",
      borderRadius: 8,
      borderWidth: 0.5,
      borderStyle: "solid",
      minHeight: 80,
      borderColor: currentTheme.borderColor,
    },
    leftContainer: {
      width: 48,
      alignItems: "center",
      overflow: "hidden",
    },
    titleText: {
      fontSize: currentTheme.typography.h2.size.mobile, // TODO: change size here?
      color: currentTheme.typography.h2.color,
    },
    itemDescriptionText: {
      fontSize: currentTheme.typography.body.size.mobile,
      color: "#444",
    },
    itemStatusText: {
      fontSize: currentTheme.typography.body.size.mobile,
      paddingTop: Spacings.s2,
      color: "#444",
    },
    rightComponent: {
      flex: 1,
      flexDirection: "column",
      alignItems: "flex-end",
      justifyContent: "space-between",
    },
    button: {
      borderRadius: 20,
      minHeight: 30,
      minWidth: 50,
      alignItems: "center",
      justifyContent: "center",
      borderWidth: 1,
      borderColor: isCompleted ? "gray" : "black",
    },
  });

  const infoComponent = (
    <>
      <Text style={styles.titleText}>{title}</Text>
      <Text style={styles.itemDescriptionText}>{description}</Text>
      <Text style={styles.itemStatusText}>{statusComponent}</Text>
    </>
  );

  const rightComponent = (
    <View style={styles.rightComponent}>
      <Text>
        {earnedScore ? `${earnedScore}/${totalScore}` : totalScore} pts
      </Text>
      <Pressable
        disabled={isCompleted}
        style={styles.button}
        onPress={() => {
          onPressActionButton();
        }}
      >
        <Text>
          {" "}
          {isCompleted ? (
            <MaterialCommunityIcons
              name={"check"}
              size={currentTheme.typography.h3.size.mobile}
              color="black"
            />
          ) : (
            "Go"
          )}
        </Text>
      </Pressable>
    </View>
  );

  return (
    <BaseItemCard
      leftComponent={<View style={styles.leftContainer}>{iconComponent}</View>}
      infoComponent={infoComponent}
      rightComponent={rightComponent}
      additionalStyle={styles.container}
    />
  );
}

export default UnlockUsersBaseCard;
